import type { PostureAnalysis } from '@/lib/types';
import type { AnalysisData, CapturedImage, CaptureSequence } from '../types';

/** Legacy handoffs used `analysisData`; persisted docs use `analysis`. */
export function getInitialAnalysisData(initial?: PostureAnalysis | null): AnalysisData {
  if (!initial) return {};
  const fromAnalysis = initial.analysis;
  if (fromAnalysis && Object.keys(fromAnalysis).length > 0) {
    return fromAnalysis;
  }
  const legacy = (initial as PostureAnalysis & { analysisData?: AnalysisData }).analysisData;
  if (legacy && typeof legacy === 'object' && Object.keys(legacy).length > 0) {
    return legacy;
  }
  return fromAnalysis && typeof fromAnalysis === 'object' ? fromAnalysis : {};
}

export function mergeInitialCapturedImages(
  initial?: PostureAnalysis | null,
): Record<CaptureSequence, CapturedImage | null> {
  const base: Record<CaptureSequence, CapturedImage | null> = {
    Anterior: null,
    Posterior: null,
    Left: null,
    Right: null,
  };
  if (!initial?.captured) return base;
  for (const view of Object.keys(initial.captured) as CaptureSequence[]) {
    const img = initial.captured[view];
    if (img) base[view] = img as CapturedImage;
  }
  return base;
}
